export default function NoteTab({ consultation }) {
  // Simulated parsed notes (ideally from backend or a formatted string)
  return (
    <div className="whitespace-pre-wrap text-base leading-relaxed text-gray-900">
      {consultation || "No note available"}
    </div>
  );
}
